
import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceCourtship from "@/views/审核管理/service/DZServiceCourtship";
import nyNetwork from "@/api/nyBaseNetwork";
import DZSearchCourtship from "@/views/审核管理/model/search/DZSearchCourtship";
import ny_config from "@/api/nyConfig";
import api from "@/api/nyApiJson";
import ImgUtil from "@/utils/ImgUtil";

@Component({
    components: {}
})
export default class Index extends Vue {

    excelName = '招商列表.xls';

    json_fields = {
        '标题': 'title',
        '地址': 'addressInfo',
        '联系人': 'contactsInfo',
        '发布状态': 'status'
    }

    toPrint() {
        this.$nyPrint.printTable(this.selections, this.json_fields, this.excelName)
    }

    imgUtil = new ImgUtil();

    $refs: any;

    table_height = 0;
    activeName = 'A'
    serve = new DZServiceCourtship();

    created() {
        this.action_page_courtship()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 130;
        })
    }

    bindImage(id) {
        if (!id) {
            return "";
        }
        let apiName = "显示图片";
        let apiJson: ny_config = api[apiName];
        let url = apiJson.baseUrl + apiJson.url + "?image=" + id
        console.log(url)
        return url;
    }

    action_page_courtship() {
        this.serve.net_page_courtship()
    }

    handle_edit(id) {
        this.$router.push({ path: "/courtship/info", query: { id: id } })
    }

    //发布状态：0-待审核，1-待交易，2-审核未通过，3-暂停，4-已过期，5-已交易
    bindStatus(status) {
        switch (status) {
            case 0: return "待审核";
            case 1: return "待交易";
            case 2: return "审核未通过";
            case 3: return "暂停发布";
            case 4: return "已过期";
            case 5: return "已交易";
            default: return status
        }
    }

    // 操作 a-通过 b-拒绝 c-暂停 d-继续
    handleCommand(id, event) {
        switch (event) {
            case "a":
                this.serve.net_courtship_pass(id, this.action_page_courtship)
                return
            case "b":
                this.serve.net_courtship_refuse(id, this.action_page_courtship)
                return
            case "c":
                this.serve.net_courtship_operate(id, this.action_page_courtship)
                return
            case "d":
                this.serve.net_courtship_operate(id, this.action_page_courtship)
                return
            default: return;
        }
    }

    el_cascader_props = {
        lazy: true,
        checkStrictly: true,
        lazyLoad(node, resolve) {
            const { level, value } = node;
            let id = 0
            if (level != 0) {
                id = value
            }
            nyNetwork.net("城市子列表", { pid: id }, data => {
                const nodes = data.map(i => {
                    return {
                        value: i.id,
                        label: i.name,
                        leaf: level >= 2
                    }
                })
                resolve(nodes)
            })
        }
    }

    clean() {
        this.serve.m_search = new DZSearchCourtship(10);
    }

    handleDbClick(row) {
        if (row.id) {
            this.handle_edit(row.id)
        }
    }

    handleSizeChange(val) {
        this.serve.m_search.pageSize = val
        this.action_page_courtship()
    }

    selections = []
    handleSelectionChange(val) {
        val.map(v => {
            v.status = this.bindStatus(v.status)
        })
        this.selections = val;
    }

    toBatchDeList() {
        if (this.selections.length == 0) {
            return
        }
        let ids = []
        this.selections.forEach(o => {
            ids.push(o.id)
        })
        this.serve.net_batch_deList(ids, this.action_page_courtship)
    }

    handleTabClick(tab) {
        if(tab.name == 'A'){
            this.serve.m_search.status = ""
        } else if(tab.name == 'B'){
            this.serve.m_search.status = "1"
        }else if(tab.name == 'C'){
            this.serve.m_search.status = "3"
        }else if(tab.name == 'D'){
            this.serve.m_search.status = "0"
        }
        this.serve.m_search.pageNum = 1
        this.action_page_courtship()
    }
}
